export const INTERNAL_SLOT_NAME = '__root';
export const NOT_FOUND_ROUTE_NAME = '+not-found';
export const SITEMAP_ROUTE_NAME = '_sitemap';
